import axios from '@/utils/axios';

export default {
  getOrganizationStat (params) {
    let url = `/stats/organization/${params.id}`;
    if (typeof params.type !== 'undefined') url = `${url}?type=${params.type}`
    return axios.get(url);
  },
  getTemplateStats (data) {
    let url = `/stats/organization`;
    return axios.post(url, data);
  },
};